'use client';

import React, { useEffect, useMemo } from 'react';
import StoreCart from './StoreCart';
import useCartStore from '@/lib/state-stores/cartStore';
import EmtyCart from './EmtyCart';
import NotFound from '@/components/NotFound';
import { useTranslations } from 'next-intl';
import LoadingCart from './LoadingCart';
import { useGetCart } from '../services/clientApi';

const useFetchCarts = () => {
  const { carts, setCarts, error } = useCartStore();

  const { data, isLoading, isError } = useGetCart();

  useEffect(() => {
    if (data) {
      setCarts(data);
    }
  }, [data, setCarts, error]);

  return { carts, isLoading, isError };
};

const ListOfCarts = ({
  onCloseCartSheet,
  isSlide,
}: {
  onCloseCartSheet?: () => void;
  isSlide?: boolean;
}) => {
  const { carts, isLoading, isError } = useFetchCarts();
  const t = useTranslations('error');

  const content = useMemo(() => {
    if (isLoading) return Array.from({ length: 3 }).map((_, i) => <LoadingCart key={i} />);
    if (isError) return <NotFound title={t('wrong')} />;
    if (!carts || carts.length === 0)
      return <EmtyCart onCloseCartSheet={onCloseCartSheet} isSlide={isSlide} />;
    return <StoreCart carts={carts} onCloseCartSheet={onCloseCartSheet} />;
  }, [carts, isLoading, isError, t, onCloseCartSheet, isSlide]);

  return <>{content}</>;
};

export default ListOfCarts;
